const DIGITS_REGEX = new RegExp(/^\d+$/);

/** Typeguard to test if the provided string contains numeric values only. */
export function hasOnlyDigits(value: string | null | undefined): value is string {
  return value == null ? false : DIGITS_REGEX.test(value);
}
